import { Text, Box } from "@chakra-ui/react";
import { getDecimalNumber, numberToDollar } from "utils/helpers";
import { getCustomCurrency } from "utils/uiconfighelper";

const LoanSearchResults = ({
  searchQuery,
  filterLoans,
  user,
  handleEntityClick,
}: {
  searchQuery: string;
  filterLoans: any;
  user: any;
  handleEntityClick: any;
}) => {
  return (
    <Box mt="20px" borderBottom="1px solid #E2E2E2">
      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <Text fontWeight={"600"} fontSize={"12px"} mb={"10px"}>
            Loans
          </Text>
          {searchQuery ? (
            filterLoans().length > 0 ? (
              filterLoans().map((loan: any) => (
                <>
                  <tr
                    key={loan.id}
                    style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      border: "1px solid white",
                      borderRadius: "90px",
                    }}
                    onClick={() => handleEntityClick("loans", loan.id)}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#F9F8F8";
                      e.currentTarget.style.border = "1px solid white";
                      e.currentTarget.style.borderRadius = "100px";
                    }}
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <Text color={"black"} ml={"8px"} mt={"8px"}>
                      <td style={{ fontWeight: 500, width: "200px" }}>
                        {loan.name}
                      </td>
                      <td
                        style={{
                          fontWeight: 500,
                          width: "150px",
                          paddingLeft: "15px",
                        }}
                      >
                        {numberToDollar(
                          getDecimalNumber(loan.amount),
                          getCustomCurrency(user),
                        )}
                      </td>
                    </Text>
                    <Text ml={"9px"}>
                      {`${loan.borrower.first_name} ${loan.borrower.last_name}`}
                    </Text>
                    <Text ml={"9px"} mb={"8px"}>
                      {loan.borrower?.company?.name}
                    </Text>
                  </tr>
                </>
              ))
            ) : (
              <tr style={{ height: "92px" }}>
                <td>
                  <Text mt={"-15px"}>No loans matched.</Text>
                </td>
              </tr>
            )
          ) : (
            <tr style={{ height: "92px" }}>
              <td>
                <Text mt={"-15px"}>Enter a search query to find loans.</Text>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default LoanSearchResults;
